export default __webpack_public_path__ + "static/media/client25.eaed13d1.png";